import { render, staticRenderFns } from "./BioSearchSetting.vue?vue&type=template&id=6a97177f"
import script from "./BioSearchSetting.vue?vue&type=script&lang=js"
export * from "./BioSearchSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports